'use client';

import type { JSONContent } from '@tiptap/core';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from 'next/image';
import styles from './TipTap.module.css';

interface TiptapViewerProps {
  content: JSONContent | null;
  imageUrl?: string | null;
  className?: string;
}

export function TiptapViewer({
  content,
  className = '',
  imageUrl
}: TiptapViewerProps) {
  const editor = useEditor({
    extensions: [StarterKit],
    content: content || undefined,
    editable: false,
    immediatelyRender: false
  });

  if (!content) {
    return null;
  }

  return (
    <div className={`${styles.tiptapViewer} ${className}`}>
      <EditorContent editor={editor} />
      {imageUrl && (
        <div className="flex justify-center">
          <Image
            src={imageUrl}
            width={450}
            height={450}
            style={{ objectFit: 'contain', borderRadius: '10px' }}
            alt="Campus de Verano"
          />
        </div>
      )}
    </div>
  );
}
